<template>
<div>
    <x-header  @on-click-back="xback" :left-options="{preventGoBack:true}">订餐查询</x-header>
      <div class="row">
          <div class="input-group col-md-11">
            <span class="input-group-addon" >工号</span>
            <input type="text" class="form-control" v-model="xtype" >
            <span class="input-group-btn">
              <button class="btn btn-default" @click.stop="initData" type="button">查询</button>
            </span>
          </div>
      </div>
<divider>合计</divider>
    <group >
      <cell title="账户余额">
        <marquee>
        <marquee-item v-for="i in 5" :key="'x'+i"  class="align-middle">{{item.epd}}元</marquee-item>
        </marquee>
      </cell>
    </group>
</div>
</template>


<script>
import { XHeader, Divider,Grid, GridItem, GroupTitle,ButtonTab,ButtonTabItem,Group, Cell, Marquee, MarqueeItem } from 'vux'

export default {
  data () {
    return {
      asyncCount: 5,
      xtype:null,
      dataList:[]
    }
  },
  methods:{
    xback(){
      this.$router.push("dc")
    },
    initData(){
      this.$getData(this.$baseUrl+"DinnerDeclare/GetEmpRC?empId=" + this.xtype, data=>{
        if (data.rs==1){
          this.dataList = data.list
        }
        setTimeout(() => {
          this.initData()
        }, 5000)
      })
    }
  },
  mounted () {
    setTimeout(() => {
      this.asyncCount = 5
    }, 1000)
  },
  components: {
    Divider,
    XHeader,
    Grid, 
    GridItem, 
    GroupTitle,
    ButtonTab,
    ButtonTabItem,Group, Cell, Marquee, MarqueeItem
  }
}
</script>
<style scoped>
document body {
  background-color: #fff import;
}
.grid-center {
  display: block;
  text-align: center;
  color: #666;
}
.weui-grids {
  background-color: #fff;
}
.align-middle {
  text-align: center;
}
.align-middle-r {
  text-align: center;
  color: red;
}
</style>
